import { GenericLazyString, gettext } from '@eventbrite/i18n';
import { css } from 'emotion';
import React from 'react';
import Button from '../../../button/Button';
import Divider from '../../../divider/Divider';
import { ISeatInfo } from '../../types';
interface ITicketLine {
    handleSelector: (_: any) => void;
    seatInfo: ISeatInfo;
    info: {
        ticketName: string;
        price: string | GenericLazyString;
        variantId: string;
        conflictingPayment?: boolean;
        complimentaryOrder: boolean;
        selectSeatsLabel: string | GenericLazyString;
    };
    showDivider?: boolean;
}

const TicketLine = ({
    handleSelector,
    seatInfo,
    info,
    showDivider,
}: ITicketLine): React.ReactElement => {
    const { ids = [] } = seatInfo;

    const {
        ticketName,
        price,
        variantId,
        conflictingPayment,
        complimentaryOrder,
        selectSeatsLabel,
    } = info || {};
    const idsLength = ids.length;
    let ticketButtonLabel: string | GenericLazyString = '';

    if (idsLength <= 1) {
        ticketButtonLabel = selectSeatsLabel || gettext('Select');
    } else {
        ticketButtonLabel =
            selectSeatsLabel ||
            gettext('Select %(idsLength)s seats', { idsLength });
    }

    return (
        <div>
            {showDivider ? (
                <div data-testid="divider">
                    <Divider />
                </div>
            ) : undefined}
            <div
                className={css({
                    display: 'grid',
                    gridTemplateColumns:
                        'repeat(auto-fit, minmax(100px, auto))',
                    justifyItems: 'end',
                    alignContent: 'space-between',
                    alignItems: 'center',
                    padding: '16px',
                    '@media (max-width: 480px)': {
                        textAlign: 'center',
                        placeItems: 'center',
                    },
                })}
            >
                <div className="eds-l-mar-right-2">
                    <p data-testid="ticket-name" className="eds-text-bl">
                        {ticketName}
                    </p>
                    {complimentaryOrder ? (
                        ''
                    ) : (
                        <p data-testid="ticket-price" className="eds-text-bm">
                            {price}
                        </p>
                    )}
                </div>
                <div data-testid="ticket-button">
                    <Button
                        onClick={() => {
                            handleSelector({ ids, variantId });
                        }}
                        disabled={conflictingPayment}
                        style={conflictingPayment ? 'fill' : null}
                    >
                        {ticketButtonLabel}
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default TicketLine;
